<template>
  <div style="z-index: 1;">
    <div class="h-b-w">
      <van-image
        class="h-b"
        src="https://oss.turingsenseai.com/1650870025207625513.png"
      />
    </div>

    <div class="content">
      <span class="logo_text">该鉴别报告由图灵鉴定小程序提供</span>
      <div class="info">
        <div class="header">
          <van-image
            width="230"
            src="https://oss.turingsenseai.com/1666495537282985547.png"
          ></van-image>
          <!-- <div class="title">{{ dataRef.muZuoResultName }}</div> -->
        </div>
        <div class="metrcis">
          <van-row>
            <van-col span="12">
              <div class="metrcis_label">鉴别结果</div>
              <div
                class="metrcis_content"
              >
                {{ dataRef.mappingResult }}
              </div>
            </van-col>
            <van-col span="12">
              <div class="metrcis_label">编号</div>
              <div
                class="metrcis_content"
              >
                {{ dataRef.OAID }}
              </div>
            </van-col>
            
          </van-row>
          <!-- <br />
          <br /> -->
          <van-row>
            <van-col span="12">
              <div class="metrcis_label">材质名称</div>
              <div
                class="metrcis_content"
              >
                {{ dataRef.material }}
              </div>
            </van-col>
            <van-col span="12">
              <div class="metrcis_label">科属名称</div>
              <div
                class="metrcis_content"
              >
                {{ dataRef.familyAndGenus }}
              </div>
            </van-col>
          </van-row>
        </div>
        <!-- <div class="divider"></div> -->
        <div class="icon-line"></div>
      </div>

      <div class="gallary">
        <div class="tab-bar">
          <perfect-scrollbar>
            <div class="scroll-view">
              <div v-for="(t, i) in dataRef.SARecordList" :key="i" class="box">
                <div :class="{ item: true }">
                  <van-image
                    :show-loading="false"
                    :src="t.image"
                    class="item"
                    fit="contain"
                    @click="changeGrade(t,i)"
                  ></van-image>
                  <div :class="{ tag: true, 'tag-active': tabActive === i }">
                    {{ t.pointName }}
                  </div>
                  <van-image
                    @click="(e) => showImage(e, i)"
                    :show-loading="false"
                    class="show-icon"
                    src="https://oss.turingsenseai.com/1650956009715204926.png"
                  ></van-image>
                </div>
              </div>
            </div>
          </perfect-scrollbar>
        </div>
        <div class="detail_grade">
          <!-- <Precent :grade="nowGrade"></Precent> -->
          <!-- <div v-if="nowPointName && nowDescription" class="point_dsc">
            <p>{{ nowDescription }}</p>
          </div> -->
          <p class="dsc_tip">
            图灵鉴定依据中质协AI鉴定团体标准对商品外观、纹理、质地进行
            检测，通过10万个特征点得出公正，客观，准确的检测结果
          </p>
        </div>
        <!-- <div class="tab">
          <div 
            v-for="(t, i) in tabs"
            :key="i"
            :class="{item: true, 'item-active': tabActive === i}">  
            <precent grade="0.9" />

          </div>

        </div> -->
      </div>

      <div class="gallary1">
        <div v-for="(t, i) in dataRef.reportImageList" :key="i" class="box">
          <div :class="{ item: true }">
            <van-image
              style="width:100%; margin-top: 20px;"
              :show-loading="false"
              :src="t"
              fit="contain"
            ></van-image>
          </div>
        </div>
      </div>
      <div class="text111">
      <div>1、本报告属于图片鉴别报告，鉴别结果根据用户上传商品图片给出</div>
      <div>2、本报告可以给商家销售和买家购物提供参考价值</div>
      <div>3、本报告不等同于有法律效力的线下实物鉴定报告</div>
      <div>4、本报告受用户委托，依据中质协《商品人工智能鉴定方法通用规范》(T/CAQI 268-2022 )团体标准，由符合该团体标准的AI算法自动给出</div>
    </div>

      <br />
      <br />
      <br />
      <br />
    </div>
  </div>
</template>

<script>
import { ImagePreview } from "vant";
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";
import { fetchZpReportDetail } from "@/common/api/appraisal.js";
// import Precent from "../../appraisal-report/components/precent1.vue";

export default {
  components: {
    [ImagePreview.Component.name]: ImagePreview.Component,
    // Precent,
  },
  data() {
    return {
      tabActive: 0,
      dataRef: {},
      nowPointName: '',
      nowDescription: ''
    };
  },
  async created() {
    console.log(this.dataRef, "---------------------");
    await fetchZpReportDetail({ OAID: this.$route.params.id }).then((res) => {
      this.isError = true;
      if (res.errorMsg == "Success") {
        this.dataRef = res;
      } else {
        this.isError = false;
      }
    });
  },
  mounted () {
    // this.changeGrade(this.dataRef.SARecordList[0],0)
  },
  methods: {
    changeTab(index) {
      this.tabActive = index;
    },
    // async getData(){
    //   fetchAppraisalReportDetailV2({serialNum: '52386544'}).then((res)=>{
    //     if (res.errorMsg == "Success") {
    //       const tmp = [];
    //       res.SARecordList.forEach((item, index) => {
    //         if (index !== 0) {
    //           tmp.push(item);
    //         }
    //       });
    //       this.tabs = tmp;
    //     }
    //   })
    // },
    showImage(e, index = 0) {
      e.preventDefault();
      e.stopPropagation();
      let images = this.dataRef.SARecordList.map((v) => v.image);
      ImagePreview({
        images,
        startPosition: index,
      });
    },
    changeGrade(detailData, i) {
      
      this.nowDescription = detailData.description
      this.nowGrade = detailData.grade
      this.nowPointName = `【${detailData.pointName}】`
      // console.log(this.nowDescription);
      // console.log(this.nowGrade);
      // console.log(this.nowPointName);
      this.tabActive = i
    }
  },
};
</script>

<style lang="scss" scoped>
.appraisal-report {
  position: relative;
  background: #f8f8fb;
}

.h-b-w {
  width: 100%;
  top: 0;
  left: 0;
  display: flex;
  position: fixed;
  justify-content: center;
  .h-b {
    height: 137 * 2px;
    position: absolute;
    width: 100%;
  }
}

.content {
  width: 100%;
  display: flex;
  position: relative;
  // justify-content: center;
  margin-top: 0;
  padding: 0px 32px;
  flex-direction: column;
  align-items: center;
  background: transparent;
  .h-t {
    width: 238px;
    z-index: 1;
  }
  .logo_text {
    display: flex;
    justify-content: center;
    padding-top: 15 * 2px;
    color: #fff;
    font-size: 12 * 2px;
  }
  .info {
    margin-top: 10* 2px;
    background: #ffffff;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 46px;
    padding-bottom: 13 * 2px;
    border-radius: 2 * 2px;
    // justify-content: center;
    .header {
      // margin-top: 40px;
      position: relative;
      display: flex;
      justify-content: center;
      width: 155* 2px;
      height: 32 * 2px;
      .title {
        position: absolute;
        top: -20px;
        font-weight: 800;
        font-size: 48px;
        text-align: center;
        color: #35424d;
      }
    }

    .metrcis {
      margin-top: 40px;
      width: 100%;
      border-bottom: 1 * 2px solid #f0f0f5;
      .metrcis_label {
        color: #828393;
        font-size:12 * 2px;
        font-weight: 400;
        line-height: 20 * 2px;
      }
      .metrcis_content {
        line-height: 20 * 2px;
        // height: 16px;
        color: #3A3D44;
        font-size: 16 * 2px;
        margin-top: 8 * 2px;
        margin-bottom: 16 * 2px;
        font-weight: 500;
      }
    }
  }

  .gallary1 {
    width: 100%;
    margin-top: 20px;
    background: #ffffff;
  }

  .gallary {
    width: 100%;
    margin-top: 20px;
    background: #ffffff;

    .tab-bar {
      .scroll-view {
        display: flex;
        // justify-content: flex-start;
        // align-items: flex-start;
        padding: 18 * 2px;
        .box {
          background: #35424d;
          margin-right: 20px;
          width: 180px;
          height: 180px;
          border-radius: 2px;
          .item {
            position: relative;
            display: inline-block;
            width: 180px;
            height: 180px;

            .show-icon {
              width: 30px;
              height: 30px;
              position: absolute;
              bottom: 10px;
              right: 10px;
            }

            .tag {
              top: 0px;
              left: 0 px;
              padding: 0 6px;
              height: 28px;
              z-index: 100;
              position: absolute;
              background-color: #efeff4;
              color: #828393;
              font-size: 16px;
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 2px;
              overflow: hidden;
              white-space: nowrap;
              max-width: 90 * 2px;
            }
            .tag-active {
              background-color: #3b95ff;
              color: #fff;
            }
          }
          .item-active {
            border-radius: 2px;
            box-shadow: 0 0 0 4px #3a94ff;
          }
        }
      }
    }
    .detail_grade {
      width: 303 * 2px;
      margin: 0 auto;
      .point_dsc{
        margin-top: 20 * 2px;
        width: 303 * 2px;
        // height: 40 * 2px;
        color: #222;
        background-color: #f5f5f5;
        font-size: 12 * 2px;
        font-weight: 500;
        p {
          display: inline-block;
          margin: 8 * 2px;
          border-radius: 2 * 2px;
        }
      }
      .dsc_tip {
        display: inline-block;
        margin: 10px 0;
        font-size: 10 * 2px;
        color: #a8a8b3;
        text-align: center;
      }
    }
    .tab {
      position: relative;
      .item {
        height: auto;
        color: #1d1d1d;
        width: 100%;
        background-color: white;
        display: none;
        &-active {
          display: block;
        }
      }
    }
  }
}

.divider {
  width: 100%;
  height: 0;
  margin-top: 30px;
  border: 0;
  border-top: 1px solid #f0f0f5;
}
.icon-line {
    display: inline-block;
    
    height: 19 * 2px;
    width: 297 * 2px;
    margin-top: 17 * 2px;
    background: url('https://oss.turingsenseai.com/1666766795485650479.png') no-repeat center;
    background-size: 121 * 2px 18 * 2px;
    background-position-x: 0;
  }
.text111{
  font-weight: 400;
  font-size: 9 * 2px;
  line-height: 19 * 2px;
  color: #828393;
  // background: #fff;
  margin-top: 20 * 2px;
  // padding: 30px;
  
  width: 343 * 2px;
}

.text111 *{
  line-height: 19 * 2px;
  font-size: 9 * 2px;
  opacity: 0.7;
}
</style>